





















































































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import WipTicket from "@/domainObjects/wip/WipTicket";
import TicketService from "@/services/TicketService";
import SubmitTicketButtonGroupMobile from "@/view/shared-components/mobile-only/SubmitTicketButtonGroupMobile.vue";
import SubmitTicketButtonGroupDesktop from "@/view/shared-components/desktop-only/SubmitTicketButtonGroupDesktop.vue";
import alertMixin from "@/mixins/alert-mixin";
import WipSAPForm from "@/view/wip/components/WipSAPForm.vue";
import WipProductInformation from "@/view/wip/components/WipProductForm.vue";
import WipCauseForm from "@/view/wip/components/WipCauseForm.vue";
import WipQiDetailsForm from "@/view/wip/components/WipQiDetailsForm.vue";
import WipQiDetails from "@/domainObjects/wip/WipQiDetails";
import screenSizeMixin from "@/mixins/screen-size-mixin";
import {mapGetters} from "vuex";
import Plant from "@/domainObjects/Plant";
import Discrepancy from "@/domainObjects/wip/Discrepancy";


@Component({
    components: {
        WipQiDetailsForm,
        WipCauseForm,
        WipProductInformation,
        WipSAPForm,
        SubmitTicketButtonGroupDesktop,
        SubmitTicketButtonGroupMobile,
    },
    mixins:[alertMixin, screenSizeMixin],
    computed: {
        // TODO: should change to mapState at some point
        ...mapGetters(['getFirstName', 'getLastName'])
    }
})

export default class AddWipTicketPage extends Vue {
    @Prop({required: false}) plant!: Plant;

    private originalWipTicketStringified: string = "";
    private wipTicket:WipTicket = new WipTicket();
    private allowSubmit: boolean = false;
    private allowReset: boolean = false;
    private getFirstName!: string;
    private getLastName!: string;
    private busy: boolean = false;
    $_alertMixin_swalConfirm!: (heading: string | null, message: string | null, type: string | null) => Promise<boolean>;
    $_alertMixin_saveSuccess!: () => void;


    @Watch('wipTicket', {immediate: true, deep: true})
    onPropertyChange(value: WipTicket, oldvalue: WipTicket){
        let newWipTicketStringified = JSON.stringify(value);
        this.allowReset = this.originalWipTicketStringified !== newWipTicketStringified;
        this.allowSubmit = !!(value.productionOrderNum &&
            value.plant.code &&
            value.plant.code.length > 0 &&
            value.productionOrderQty &&
            value.materialDesc &&
            value.materialNum &&
            value.onHoldBy &&
            value.salesOrderNum &&
            value.lineItem &&
            value.color &&
            value.optionNumber &&
            value.stackNumOnHold &&
            value.stacksOnHold &&
            value.shiftProduced &&
            value.qtyOnHold &&
            value.discrepancy &&
            (Discrepancy.isMissing(value.discrepancy) ? value.missingPartQty && value.missingPartNumber : true) &&
            value.workCenter &&
            value.prodDate &&
            value.comments);
    }

    beforeMount(){
        this.setInitialValues()
    }

    mounted(){
        this.wipTicket.onHoldBy = this.getFirstName + ' ' + this.getLastName;
    }

    setInitialValues(){
        this.wipTicket = new WipTicket();
        let wipTicketObj:any = {};
        wipTicketObj.plant = {};
        wipTicketObj.status = {};
        if (this.plant){
            wipTicketObj.plant = this.plant;
        }
        wipTicketObj.onHoldDate = new Date();
        wipTicketObj.status.id = 1;
        wipTicketObj.status.desc = 'Open';
        wipTicketObj.returnAuthNum = 'N/A';
        wipTicketObj.purchaseOrderNum = 'N/A';
        wipTicketObj.cparNumber = 'N/A';
        wipTicketObj.reverificationRequired = 'N/A';
        wipTicketObj.color = 'N/A';
        wipTicketObj.optionNumber = 'N/A';
        wipTicketObj.defect = {};
        wipTicketObj.disposition = {};
        wipTicketObj.qiHoldDetails = [new WipQiDetails()];
        this.wipTicket.initFromObject(wipTicketObj);
        this.wipTicket.loaded = true;
        this.originalWipTicketStringified = JSON.stringify(this.wipTicket);
    }

    onSubmit() {
        let self = this;
        this.$_alertMixin_swalConfirm('Submit Ticket', null, null).then((value) => {
            if (value){
                self.busy = true;
                let wipTicketJSON = JSON.stringify(self.wipTicket);
                TicketService.createWipTicket(wipTicketJSON).then((response)=> {
                    self.wipTicket.wipTicketId = parseInt(response.data)
                    self.$_alertMixin_saveSuccess();
                    self.busy = false;
                    // @ts-ignore
                    this.$router.push({name: 'wip-tickets', params: {updatedTicket: this.wipTicket, updatedTicketType:'created'}})
                }).catch((error)=> {
                });
            }
        });

    }
    onReset() {

        this.wipTicket.loaded = false;
        this.$nextTick(() => {
            this.wipTicket = {} as WipTicket;
            this.setInitialValues();
        });
    }
}

